import {ALLOWED_LANGUAGES} from '../i18n.constants';
import {brandingLngs, initI18next} from '../i18n';

import type {Manifest} from './types';
import {getBrandingPath} from './loadBranding';

const isValidAvailableLanguages = (
    availableLngs: string[] | undefined,
    allLngs: string[],
) => {
    if (!availableLngs || availableLngs.length === 0) {
        return false;
    }
    return availableLngs.some(lng => allLngs.includes(lng));
};

export const setLanguages = (
    availableLanguages: Manifest['availableLanguages'],
    translations: Manifest['translations'],
) => {
    let allLanguages = [
        ...ALLOWED_LANGUAGES,
        ...Object.keys(translations).filter(
            k => !ALLOWED_LANGUAGES.includes(k),
        ),
    ];

    for (const [lng, path] of Object.entries(translations)) {
        brandingLngs.set(lng, getBrandingPath(path));
    }

    // If available languages are defined: All languages = available languages
    if (isValidAvailableLanguages(availableLanguages, allLanguages)) {
        allLanguages = allLanguages.filter(lng =>
            availableLanguages?.includes(lng),
        );
    }

    void initI18next(allLanguages, true);

    return allLanguages;
};
